import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatListOption, MatSelectionList } from '@angular/material/list';
import { createUserDetailsForm } from '../../models/user-details-form';
import { UserEntitlementOption } from '../../models/entitlements';

@Component({
  selector: 'app-selection-list',
  imports: [FormsModule, MatButton, MatListOption, MatSelectionList, ReactiveFormsModule],
  templateUrl: './selection-list.component.html',
  styleUrl: './selection-list.component.scss'
})
export class SelectionListComponent {
  @Input() group = createUserDetailsForm();
  @Input() title = '';
  @Input() controlName = '';
  @Input() entitlementList: UserEntitlementOption[] | null = null;

  get enabledKeys(): string[] {
    return this.entitlementList?.filter(entitlement => !entitlement.disabled).map(({ key }) => key) ?? [];
  }

  get selectedValues(): string[] {
    return this.group.get(this.controlName)?.value ?? [];
  }

  selectAllEnabled() {
    if (!this.entitlementList) return;
    this.group.get(this.controlName)?.setValue(this.enabledKeys);
  }

  deselectAll() {
    this.group.get(this.controlName)?.setValue([]);
  }

  allEnabledSelected() {
    const enabled = this.enabledKeys;
    if (enabled.length === 0) return false;
    return enabled.every(key => this.selectedValues.includes(key));
  }
}
